import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { dispatch, useGlobalState } from '../../store/state';
import { Col, message, Result, Skeleton, Input, Select, Button } from 'antd';
import BaseLayoutComponent from '../../components/Layout/Admin/BaseLayoutComponent';
import TopSubHeaderComponent from '../../components/Admin/Common/TopSubHeaderComponent';
import { AiOutlineSearch } from 'react-icons/ai';
import CampaignsTableComponent from '../../components/Admin/Campaigns/CampaignsTableComponent';
import { useHistory } from 'react-router';

export const AdminCampaignsPage = () => {
  const history = useHistory();

  return (
    <BaseLayoutComponent>
      <TopSubHeaderComponent className="px-3 py-2 sticky">
        <div className="row align-items-center">
          <div className="col-md-5">
            <h6 className="m-0"><strong>Campaigns</strong>
              {/* <span className="px-1">|</span>
                        <span>1 in active</span> */}
            </h6>
          </div>
          <div className="col-md-7 pl-2 text-right">
            <Button className="common_button"
              onClick={() => {
                history.push('/admin/campaign/create');
              }}>Create Campaign</Button>
          </div>
        </div>
      </TopSubHeaderComponent>
      <div className="d-flex py-3">
        <div className="col-md-12">
          <CampaignsTableComponent/>
        </div>
      </div>
    </BaseLayoutComponent>
  );
};
